/**
 * Aws cognito configurations
 */
const authConfig = {
  Auth: {
    // Amazon cognito identity pool id
    identityPoolId: "ap-southeast-2:71952d7b-b1f3-414a-918a-e4d41f92a71e",
    // Amazon cognito region
    region: "ap-southeast-2",
    // Amazon cognito user pool id
    userPoolId: "ap-southeast-2_VztWr846x",
    // Amazon cognito web client id (26 char alphanumeric string)
    userPoolWebClientId: "1cnmqv3lbpnlbf8tnrk42n7ovb",
    // authenticationFlowType: 'REFRESH_TOKEN_AUTH'
  },
  // Hosted UI Configuration
  oauth: {
    domain: "auth.plc.sydney",
    scope: [
      "phone",
      "email",
      "profile",
      "openid",
      "aws.cognito.signin.user.admin",
    ],
    redirectSignIn: "http://localhost:3000",
    redirectSignOut:
      "https://auth.plc.sydney/login?client_id=1cnmqv3lbpnlbf8tnrk42n7ovb&response_type=token&scope=aws.cognito.signin.user.admin+email+openid+phone+profile&redirect_uri=http://localhost:3000",
    responseType: "token",
  },
};

export const authConfigs = authConfig;
